/**
 * Shop goods: English.
 *
 * On why this file is separate, see goods-ru.ts.
 *
 * ⚠️ TRADE NAMES, NOT DESCRIPTIONS. An angler scans a shop for "feeder rod"
 * and "baitrunner reel", not for "rod for bottom fishing with a feeder".
 * Sizes stay in the shop's own convention: metres with a dot, hook sizes as
 * numbers.
 */
export const ТОВАРЫ_EN: Record<string, string> = {
  // ── было в общем словаре ──
  'item.test': 'rated to',
  'item.drag': 'drag up to',
  'item.dive': 'running depth',
  'item.action_fast': 'fast action',
  'item.action_medium': 'medium action',
  'item.action_slow': 'slow action',
  'item.mat_mono': 'mono',
  'item.mat_fluoro': 'fluorocarbon',
  'item.mat_braid': 'braid',
  'item.rod_medium': 'Medium spinning rod, 2.4 m',
  'item.rod_ultralight': 'Ultralight spinning rod, 1.98 m',
  'item.rod_light': 'Light spinning rod, 2.13 m',
  'item.rod_heavy': 'Heavy spinning rod, 2.7 m',
  'item.reel_stock': 'Reel 2500',
  'item.reel_3000': 'Reel 3000',
  'item.reel_4000': 'Reel 4000',
  'item.line_mono_024': 'Mono 0.24 mm',
  'item.line_mono_030': 'Mono 0.30 mm',
  'item.line_fluoro_022': 'Fluorocarbon 0.22 mm',
  'item.line_braid_014': 'Braid 0.14 mm',
  'item.line_braid_020': 'Braid 0.20 mm',
  'item.lure_spoon_18': 'Spoon 18 g',
  'item.lure_spinner_8': 'Spinner 8 g',
  'item.lure_wobbler_12': 'Crankbait 12 g',
  'item.lure_wobbler_deep': 'Deep crankbait 16 g',
  'item.lure_jig_14': 'Jig 14 g',
  'item.lure_jig_24': 'Jig 24 g',
  'item.lead_fluoro': 'Fluorocarbon leader 0.20 mm',
  'item.lead_steel': 'Steel leader 12 kg',
  'item.hook_10': 'Hook no. 10',
  'item.hook_8': 'Hook no. 8',
  'item.hook_6': 'Hook no. 6',
  'item.hook_4': 'Hook no. 4',
  'item.bait_corn': 'Sweetcorn',
  'item.bait_worm': 'Dendrobena worm',
  'item.bait_maggot': 'Maggots',
  'item.bait_fry': 'Live fry',
  'item.gb_basic': 'Basic groundbait',
  'item.gb_aroma': 'Flavoured groundbait',
  'item.food_sandwich': 'Sandwich',
  'item.food_tea': 'Flask of tea',
  'item.food_stew': 'Tinned stew',
  'item.food_ration': 'Day ration',
  'item.keep_150': 'Keepnet for 150',
  'item.keep_250': 'Keepnet for 250',
  'item.keep_400': 'Keepnet for 400',
  'item.sonar_shore': 'Shore sonar',
  'item.sonar_far': 'Long-range sonar',
  'item.boat_row': 'Rowing boat',
  'item.boat_motor': 'Motor boat',
  'item.net_small': 'Small landing net',
  'item.net_big': 'Large landing net',
  'item.lamp_head': 'Head torch',
  'item.lamp_camp': 'Camp lantern',
  'item.tent_solo': 'One-man tent',
  'item.tent_duo': 'Two-man tent',
  'item.cloth_rain': 'Rain jacket',
  'item.cloth_warm': 'Thermal suit',
  'item.gear_chair': 'Folding chair',
  'item.gear_box': 'Tackle box',
  'item.gear_thermos': 'Thermos',
  'item.gear_scales': 'Scales',
  'item.gear_tape': 'Measuring tape',
  'item.gear_stringer': 'Stringer',


  // ── удилища ──
  'item.rod_spin_ul_21': 'Ultralight spinning rod 2.10 m',
  'item.rod_spin_jig_27': 'Jigging spinning rod 2.70 m',
  'item.rod_spin_twitch_21': 'Twitching spinning rod 2.10 m',
  'item.rod_spin_sea_30': 'Heavy spinning rod 3.00 m',
  'item.rod_feeder_33': 'Light feeder rod 3.30 m',
  'item.rod_feeder_36': 'Medium feeder rod 3.60 m',
  'item.rod_feeder_39': 'Heavy feeder rod 3.90 m',
  'item.rod_match_42': 'Match rod 4.20 m',
  'item.rod_bolo_50': 'Bolognese rod 5.00 m',
  'item.rod_pole_60': 'Whip pole 6.00 m',
  'item.rod_carp_36': 'Carp rod 3.60 m',
  'item.rod_fly_5': 'Fly rod, 5 weight',
  'item.rod_fly_8': 'Fly rod, 8 weight',
  'item.rod_tele_40': 'Telescopic rod 4.00 m',
  'item.rod_troll_24': 'Trolling rod 2.40 m',
  'item.rod_ice': 'Ice fishing rod',

  // ── катушки ──
  'item.reel_1000': 'Reel, size 1000',
  'item.reel_2000': 'Reel, size 2000',
  'item.reel_5000': 'Reel, size 5000',
  'item.reel_8000': 'Reel, size 8000',
  'item.reel_baitrunner': 'Baitrunner reel',
  'item.reel_feeder': 'Feeder reel',
  'item.reel_rear_drag': 'Rear-drag reel',
  'item.reel_carp_big': 'Big-pit carp reel',
  'item.reel_multi': 'Baitcasting reel',
  'item.reel_troll': 'Trolling reel',
  'item.reel_fly': 'Fly fishing reel',
  'item.reel_ice': 'Ice fishing reel',

  // ── леска ──
  'item.line_mono_016': 'Monofilament 0.16 mm',
  'item.line_mono_020': 'Monofilament 0.20 mm',
  'item.line_mono_028': 'Monofilament 0.28 mm',
  'item.line_mono_035': 'Monofilament 0.35 mm',
  'item.line_fluoro_018': 'Fluorocarbon 0.18 mm',
  'item.line_fluoro_028': 'Fluorocarbon 0.28 mm',
  'item.line_braid_010': 'Braided line 0.10 mm',
  'item.line_braid_025': 'Braided line 0.25 mm',
  'item.line_feeder_022': 'Feeder line 0.22 mm',
  'item.line_carp_030': 'Carp line 0.30 mm',
  'item.line_ice_012': 'Ice fishing line 0.12 mm',
  'item.line_shock': 'Shock leader',

  // ── поводки ──
  'item.lead_mono': 'Monofilament leader 0.16 mm',
  'item.lead_titan': 'Titanium leader, 9 kg',
  'item.lead_tungsten': 'Tungsten leader, 7 kg',
  'item.lead_kevlar': 'Kevlar leader, 15 kg',
  'item.lead_carp': 'Braided carp hooklink',
  'item.lead_fly': 'Fly tapered leader',

  // ── крючки ──
  'item.hook_14': 'Hook, size 14',
  'item.hook_12': 'Hook, size 12',
  'item.hook_2': 'Hook, size 2',
  'item.hook_1_0': 'Hook, size 1/0',
  'item.hook_treble': 'Treble hook',
  'item.hook_double': 'Double hook',
  'item.hook_offset': 'Offset worm hook',
  'item.hook_carp': 'Carp hook',

  // ── приманки ──
  'item.lure_spoon_7': 'Spoon, 7 g',
  'item.lure_spoon_28': 'Spoon, 28 g',
  'item.lure_spinner_3': 'Spinner, 3 g',
  'item.lure_spinner_14': 'Spinner, 14 g',
  'item.lure_minnow_90': 'Minnow lure, 90 mm',
  'item.lure_crank_60': 'Crankbait, 60 mm',
  'item.lure_shad_70': 'Shad lure, 70 mm',
  'item.lure_popper_80': 'Popper, 80 mm',
  'item.lure_walker_95': 'Walking lure, 95 mm',
  'item.lure_jerk_130': 'Jerkbait, 130 mm',
  'item.lure_swim_150': 'Jointed swimbait, 150 mm',
  'item.lure_jighead_12': 'Jig head, 12 g',
  'item.lure_sil_worm': 'Soft plastic worm',
  'item.lure_sil_shad': 'Soft plastic shad',
  'item.lure_sil_twister': 'Soft plastic grub',
  'item.lure_mandula': 'Mandula lure',
  'item.lure_fly_wet': 'Wet fly',
  'item.lure_fly_dry': 'Dry fly',

  // ── наживка ──
  'item.bait_bloodworm': 'Bloodworm',
  'item.bait_barley': 'Pearl barley',
  'item.bait_dough': 'Paste',
  'item.bait_peas': 'Peas',
  'item.bait_boilie': 'Boilies',
  'item.bait_pellets': 'Pellets',
  'item.bait_mussel': 'Freshwater mussel',
  'item.bait_shrimp': 'Freshwater shrimp',
  'item.bait_bread': 'Bread flake',
  'item.bait_cheese': 'Cheese',

  // ── прикормка ──
  'item.gb_bream': 'Bream groundbait',
  'item.gb_carp': 'Carp groundbait',
  'item.gb_roach': 'Roach groundbait',
  'item.gb_feeder': 'Feeder groundbait',
  'item.gb_winter': 'Winter groundbait',
  'item.gb_dip': 'Flavour dip',
  'item.gb_pva': 'PVA bags',
  'item.gb_soil': 'Groundbait soil',

  // ── еда ──
  'item.food_soup': 'Pot of fish soup',
  'item.food_coffee': 'Coffee',
  'item.food_energy': 'Energy drink',
  'item.food_bar': 'Cereal bar',

  // ── садки ──
  'item.keep_60': 'Keepnet, 60 cm',
  'item.keep_cage': 'Rubberised keepnet',
  'item.keep_sack': 'Carp sack',

  // ── эхолоты ──
  'item.sonar_wireless': 'Wireless fish finder',
  'item.sonar_color': 'Colour fish finder with mapping',
  'item.sonar_ice': 'Ice fishing flasher',

  // ── лодки ──
  'item.boat_pvc': 'PVC inflatable boat',
  'item.boat_outboard': 'Outboard motor',
  'item.boat_mount': 'Fish finder mount',
  'item.boat_anchor': 'Boat anchor',

  // ── снаряжение ──
  'item.gear_forceps': 'Hook disgorger',
  'item.gear_pliers': 'Fishing pliers',
  'item.gear_mat': 'Carp unhooking mat',
  'item.gear_rodpod': 'Rod pod',
  'item.gear_umbrella': 'Fishing umbrella',
  'item.gear_bag': 'Tackle bag',
  'item.gear_bucket': 'Groundbait bucket',
  'item.gear_polar': 'Polarised glasses',

  // ── нахлыст: вторая сотня видов ──
  'item.fly_line_5': 'Fly line, 5 weight',
  'item.fly_line_8': 'Fly line, 8 weight',
  'item.fly_backing': 'Fly backing line',
  'item.fly_tippet': 'Tippet material',
  'item.fly_box': 'Fly storage box',
  'item.fly_dry_set': 'Set of dry flies',
  'item.fly_wet_set': 'Set of wet flies',
  'item.fly_nymph_set': 'Set of nymphs',
  'item.fly_streamer': 'Streamer fly',
  'item.fly_hegene': 'Hegene nymph rig',
  'item.fly_floatant': 'Fly floatant',
  'item.fly_sink': 'Sinking paste',
  'item.fly_vice': 'Fly tying vice',

  // ── наживка: вторая сотня видов ──
  'item.bait_caddis': 'Caddis larva',
  'item.bait_roe': 'Salmon roe',
  'item.bait_cut': 'Cut bait',
  'item.bait_grasshopper': 'Grasshopper',
  'item.bait_algae': 'Filamentous algae',
  'item.bait_frog': 'Live frog',
  'item.bait_fruit': 'Fruit bait',
  'item.bait_meat': 'Meat bait',
  'item.bait_mussel_tropic': 'Large river mussel',

  // ── поводки: вторая сотня видов ──
  'item.lead_wire_20': 'Wire leader, 20 kg',
  'item.lead_wire_40': 'Wire leader, 40 kg',
  'item.lead_shock_heavy': 'Heavy shock leader, 60 kg',
  'item.lead_mono_heavy': 'Heavy monofilament leader, 1.0 mm',

  // ── крючки: вторая сотня видов ──
  'item.hook_3_0': 'Hook, size 3/0',
  'item.hook_6_0': 'Hook, size 6/0',
  'item.hook_circle': 'Circle hook',
  'item.hook_fly': 'Fly tying hook',

  // ── снаряжение: вторая сотня видов ──
  'item.gear_waders': 'Chest waders',
  'item.gear_boots': 'Wading boots',
  'item.gear_glove': 'Landing glove',
  'item.gear_lipgrip': 'Fish lip grip',
  'item.gear_gaff': 'Landing gaff',
  'item.gear_cooler': 'Cool bag',
  'item.gear_repellent': 'Insect repellent',
  'item.gear_marker': 'Marker float',

  'item.float_light_1g': "Light float 1 g",
  'item.float_mid_3g': "Medium float 3 g",
  'item.float_heavy_6g': "Heavy float 6 g",

  'item.float_quill_05': 'Quill float 0.5 g',
  'item.float_waggler_4g': 'Waggler 4 g',
  'item.float_slider_8g': 'Slider float 8 g',
  'item.rod_pole_90': 'Pole rod 9.00 m',
};
